/* global courses */
import React from 'react';
import PropTypes from 'prop-types';
import GoogleMapSimple from '../SimpleMap.jsx';

const AccomodationMap = props => (
    <div>
        <GoogleMapSimple schools={[{ schoolname: props.name, lat: props.lat, lng: props.lng }]} />
    </div>
);

AccomodationMap.propTypes = {
    name: PropTypes.string,
    lat: PropTypes.string,
    lng: PropTypes.string,
};

export default AccomodationMap;
